module.exports = __webpack_public_path__ + "assets/imgs/news-page-img-7.v1.jpg";